import React from "react";

const WhiteNavbar = () => {
  return <div className="white-navbar"></div>;
};

export default WhiteNavbar;
